import { render, staticRenderFns } from "./validationModal.vue?vue&type=template&id=6bff84b4&"
import script from "./validationModal.vue?vue&type=script&lang=js&"
export * from "./validationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports